export default __webpack_public_path__ + "static/media/026-speed limit.45d92974.png";